<div
  class="product-card flex h-full cursor-pointer flex-col overflow-hidden transition-all duration-300"
  (click)="!isProductAvailable() ? null : addToCart()"
>
  <!-- Product Image -->
  <div class="imageContainer relative h-48 overflow-hidden">
    <div
      class="absolute inset-0 h-48 w-full"
      [appRadialGradient]="product()[ProductKeys.Images]?.thumbnail?.colors"
    ></div>
    @if (product()[ProductKeys.Images]?.thumbnail?.url) {
      <img
        [src]="product()[ProductKeys.Images]?.thumbnail?.url"
        [alt]="product()[ProductKeys.Name]"
        class="relative z-10 h-full w-full object-cover transition-transform duration-300"
        loading="lazy"
      />
    }

    <!-- Discount Badge -->
    <div
      *ngIf="displayDiscount()"
      class="absolute right-2 top-2 rounded-full bg-green-500 px-2 py-1 text-xs font-bold text-white shadow-lg"
    >
      {{ discountPercentage() }}%
    </div>

    <!-- Unavailable Overlay -->
    <div
      *ngIf="!isProductAvailable()"
      class="absolute inset-0 z-20 flex items-center justify-center bg-black bg-opacity-50"
    >
      <span class="text-lg font-bold text-white">{{ '_.UNAVAILABLE' | translate }}</span>
    </div>
  </div>

  <!-- Product Content -->
  <div class="flex flex-1 flex-col justify-between p-4">
    <!-- Product Name -->
    <div class="mb-3">
      <h3
        class="line-clamp-2 text-lg font-bold leading-tight"
        [style.color]="(textColor() | contentBuilderColor) || '#333333'"
      >
        {{ product()[ProductKeys.Name] }}
      </h3>
    </div>

    <div class="mt-auto flex items-center justify-between">
      <!-- Price -->
      <div class="flex-1">
        <app-price-atom
          [amount]="
            +(
              product()[ProductKeys.PriceToDisplay] ||
              product()[ProductKeys.Discount] ||
              product()[ProductKeys.Price] ||
              0
            )
          "
          [bold]="true"
          size="XL"
          class="text-xl font-bold"
        ></app-price-atom>
      </div>

      <div class="">
        @if (product().description?.length || product().allergens?.length) {
          <i
            (click)="!isProductAvailable() ? null : showProductModal(); $event.stopPropagation()"
            class="icon icon-c-info-3 pointer-events-auto content-center text-center text-2xl font-semibold"
            [style.color]="textColor() | contentBuilderColor"
            [class.opacity-50]="!isProductAvailable()"
          ></i>
        }
      </div>
    </div>

    <!-- Quantity Indicator -->
    <div
      *ngIf="quantity() && quantity()! > 0"
      class="absolute -right-2 -top-2 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-orange-500 text-sm font-bold text-white shadow-lg"
    >
      {{ quantity() }}
    </div>
  </div>
</div>
